
// import React, { useEffect, useState, useRef } from 'react'
// import '../css/viewGame1.css'
// import '../css/layout.css'
// import axios from 'axios'
// import { useHistory, useLocation } from 'react-router-dom'
// import Header from '../Components/Header'
// import css from '../css/Pan.module.css'
// import Rightcontainer from '../Components/Rightcontainer'
// import Swal from 'sweetalert2'
// import '../css/Loader.css'
// import io from '../Components/socket'
// import Compressor from 'compressorjs'

// export default function ViewGame1(props) {
//   const history = useHistory()

//   const location = useLocation()
//   const path = location.pathname.split('/')[2]

//   const [Game, setGame] = useState('0')
//   const [status, setStatus] = useState(null)
//   const [fecthStatus, setFecthStatus] = useState()
//   const [scrnshot, setScrnshot] = useState(null)
//   const [scrnshot1, setScrnshot1] = useState('') // ADDED BY TEAM
//   const [initialRoom, setInitialRoom] = useState('')
//   //  console.log(scrnshot,"27")
//   const [reason, setReason] = useState(null)

//   const [roomcode, setRoomcode] = useState()
//   let submitReq = useRef(false)
//   const isMounted = useRef(true)

//   const [submitProcess, setProcess] = useState(true)


  
//   useEffect(() => {
//     io.on('updateroomcode', data => {
//       getCode()
//     })
//   }, [initialRoom.Room_code == 0])


//   useEffect(() => {
//     getCode()
//   }, [])
//   const getPost = async () => {
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }
//     await axios
//       .patch(
//         `https://api.rrludo.in/challange/roomcode/${path}`,
//         {
//           Room_code: roomcode
//         },
//         { headers }
//       )
//       .then(res => {
//         console.log(res?.data)
//         if (res?.status) {
//           setGame(res.data)
//         } else {
//           Swal.fire("invalid room code ")
//         }

//         // io.emit('challengeOngoing')
//       })
//       .catch(e => {
//         if (e.response.status == 401) {
//           localStorage.removeItem('token')
//           localStorage.removeItem('token')
//           window.location.reload()
//           history.push('/login')
//         }
//       })
//   }
//   /// user details start



//   const [user, setUser] = useState()
//   const [userAllData, setUserAllData] = useState()

//   const role = async () => {
//     const access_token = localStorage.getItem('token')

//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }
//     await axios
//       .get(`https://api.rrludo.in/me`, { headers })
//       .then(res => {
//         setUser(res.data._id)
//         setUserAllData(res.data)

//         Allgames(res.data._id)

//         getCode(res.data._id)

//       })
//       .catch(e => {
//         if (e.response.status == 401) {
//           localStorage.removeItem('token')
//           localStorage.removeItem('token')
//           window.location.reload()
//           history.push('/login')
//         }
//       })
//   }

//   /// user details end

//   const [ALL, setALL] = useState()

//   const Allgames = async userId => {
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }

//     await axios
//       .get(`https://api.rrludo.in/challange/${path}`, { headers })
//       .then(res => {
//         if (res.data.Status == 'new' || res.data.Status == 'requested') {
//           setTimeout(async () => {
//             await axios
//               .get(`https://api.rrludo.in/challange/${path}`, { headers })
//               .then(res => {
//                 if (
//                   res.data.Status == 'new' ||
//                   res.data.Status == 'requested'
//                 ) {
//                   history.push(props.location.state.prevPath)
//                 } else {
//                   setProcess(false)
//                 }
//               })
//               .catch(error => {
//                 console.error(error)
//                 history.push(props.location.state.prevPath)
//               })
//           }, 10000)
//         } else {
//           setProcess(false)
//         }
//         setALL(res.data)
//         setGame(res.data)
//         // // console.log(res.data.Accepetd_By._id)
//         if (userId == res.data.Accepetd_By._id)
//           setFecthStatus(res.data.Acceptor_status)

//         if (userId == res.data.Created_by._id)
//           setFecthStatus(res.data.Creator_Status)
//       })
//       .catch(e => {
//         if (e.response?.status == 401) {
//           localStorage.removeItem('token')
//           localStorage.removeItem('token')
//           window.location.reload()
//           history.push('/login')
//         }
//       })
//   }
//   const getCode = async userId => {
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }

//     await axios
//       .get(`https://api.rrludo.in/game/roomcode/get/${path}`, { headers })
//       .then(res => {
//         //setALL(res.data)
//         setInitialRoom(res.data)
//         Allgames(userId)
//         if (res.data.Accepetd_By == user && res.data.Room_code == 0) {
//           setTimeout(async () => {
//             window.location.reload()
//           }, 10000)
//         }
//       })
//   }
//   const checkExpire = async () => {
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }

//     await axios
//       .get(`https://api.rrludo.in/game/roomcode/expire/${path}`, {
//         headers
//       })
//       .then(res => {
//         history.goBack()
//       })
//   }

//   useEffect(() => { }, [io])

//   useEffect(() => {
//     let access_token = localStorage.getItem('token')
//     access_token = localStorage.getItem('token')
//     if (!access_token) {
//       window.location.reload()
//       history.push('/login')
//     }
//     // console.log(history.location)

//     role()
//   }, [])

//   const clearImage = e => {
//     setScrnshot1(null)
//     setScrnshot(null)
//     setStatus(null)
//   }
//   // Result

//   const Result = async e => {
//     e.preventDefault()
//     if (submitReq.current == false) {
//       submitReq.current = true
//       const access_token = localStorage.getItem('token')
//       const headers = {
//         Authorization: `Bearer ${access_token}`
//       }
//       if (status) {
//         setProcess(true)
//         const formData = new FormData()
//         formData.append('file', scrnshot)
//         formData.append('status', status)
//         if (status == 'cancelled') {
//           formData.append('reason', reason)
//         }

//         await axios({
//           method: 'post',
//           url: `https://api.rrludo.in/challange/result/${path}`,
//           data: formData,
//           headers: headers
//         })
//           .then(res => {
//             io.emit('resultAPI')
//             // socket.emit('resultAPI');
//             submitReq.current = false
//             setProcess(false)
//             history.push(props.location.state.prevPath)
//           })
//           .catch(e => {
//             console.log(e)
//             if (e.response.status == 401) {
//               localStorage.removeItem('token')
//               localStorage.removeItem('token')
//               window.location.reload()
//               history.push('/login')
//             }
//           })
//       } else {
//         submitReq.current = false
//         alert('please fill all field or Re-Select result status')
//       }
//     }
//   }

//   const copyCode = e => {
//     // console.log(Game.Room_code);
//     navigator.clipboard.writeText(Game.Room_code)

//     Swal.fire({
//       position: 'center',
//       icon: 'success',
//       type: 'success',
//       title: 'Room Code Copied',
//       showConfirmButton: false,
//       timer: 1200
//     })
//   }
//   const Completionist = () => <span>You are good to go!</span>

//   // ADDED BY TEAM
//   const handleChange = e => {
//     setScrnshot1(URL.createObjectURL(e.target.files[0]))
//     const image = e.target.files[0]
//     // console.log("orignal",image.size/1000>300)
//     if (image && image.size / 1000 > 300) {
//       console.log(' compression')
//       new Compressor(image, {
//         quality: 0.6,
//         success(compressedResult) {
//           // console.log(compressedResult)
//           if (compressedResult) {
//             setScrnshot(compressedResult)
//           } else {
//             setScrnshot(image)
//           }
//         }
//       })
//     } else {
//       console.log('no compression')
//       setScrnshot(e.target.files[0])
//     }
//   }
//   const [siteSetting, setsiteSetting] = useState([])

//   useEffect(() => {
//     const items = JSON.parse(localStorage.getItem('sitSetting'))
//     if (items) {
//       setsiteSetting(items)
//     }
//   }, [])

//   // -----Start timer ------------------------------------------------------------------------
//   const [showDiv, setShowDiv] = useState(true)
//   const [secondsRemaining, setSecondsRemaining] = useState(null)

//   // Replace this with the actual timestamp from MongoDB
//   const createdAtTimestamp = new Date(Game.createdAt).getTime() // Example timestamp

//   useEffect(() => {
//     const calculateTimeRemaining = () => {
//       const currentTime = new Date().getTime()
//       const differenceInSeconds = Math.floor(
//         (currentTime - createdAtTimestamp) / 1000
//       )
//       //  console.log(differenceInSeconds,showDiv)
//       if (differenceInSeconds >= 240) {
//         setShowDiv(false)
//       } else {
//         setSecondsRemaining(240 - differenceInSeconds)
//       }
//     }

//     calculateTimeRemaining() // Calculate initial time remaining

//     // Update time remaining every second
//     const timer = setInterval(() => {
//       calculateTimeRemaining()
//     }, 1000)

//     return () => {
//       clearInterval(timer)
//     }
//   }, [createdAtTimestamp])

//   // -----end timer------
//   const handleSetRoomCode = () => {
//     const inputValue = roomcode

//     if (
//       /^[0-9]+$/.test(inputValue) &&
//       inputValue.length === 8 &&
//       inputValue[0] === '0'
//     ) {
//       getPost()
//     } else {
//       Swal.fire({
//         position: 'center',
//         icon: 'error',
//         title: 'Please enter a valid 8-digit code that starts with 0.',
//         showConfirmButton: true
//       })
//     }
//   }


//   return (
//     <>
//       <Header user={userAllData} />
//       {/* {!Game && <div class="lds-ripple"><div></div><div></div></div>} */}
//       {Game && (
//         <div className='leftContainer'>
//           <div className='pt-5 mt-5 Orher_page_main_section'>
//             {/* <div class='home_message_div'>
//               <p class=''>{siteSetting?.site_message}</p>
//             </div> */}
//             {!Boolean(submitProcess) && (
//               <div className='battleCard-bg'>
//                 <div className='battleCard'>
//                   <div className="container my-3">
//                     <div className="card shadow-lg border-0 rounded-4 p-3 text-center" style={{ maxWidth: "400px", margin: "0 auto" }}>
//                       <div className="card-body">
//                         {/* Players Section */}
//                         <div className="d-flex justify-content-between align-items-center">
//                           {/* Created By Player */}
//                           <div className="d-flex flex-column align-items-center">
//                             <img
//                               src={
//                                 Game?.Created_by?.avatar
//                                   ? `https://api.rrludo.in/${Game?.Created_by?.avatar}`
//                                   : "/images/avatars/Avatar1.png"
//                               }
//                               onError={(e) => {
//                                 e.target.onerror = null
//                                 e.target.src = "/images/avatars/Avatar1.png"
//                               }}
//                               width="70"
//                               height="70"
//                               alt="player1"
//                               className="rounded-circle border border-2 border-primary shadow-sm"
//                             />
//                             <h6 className="mt-2 fw-semibold text-primary">
//                               {Game?.Created_by?.Name || "Player 1"}
//                             </h6>
//                           </div>

//                           {/* Versus Image */}
//                           <img
//                             src={process.env.PUBLIC_URL + "/images/Homepage/versus.png"}
//                             alt="versus"
//                             width="40"
//                             className="mx-3"
//                           />

//                           {/* Accepted By Player */}
//                           <div className="d-flex flex-column align-items-center">
//                             <img
//                               src={
//                                 Game?.Accepetd_By?.avatar
//                                   ? `https://api.rrludo.in/${Game?.Accepetd_By?.avatar}`
//                                   : "/images/avatars/Avatar2.png"
//                               }
//                               onError={(e) => {
//                                 e.target.onerror = null
//                                 e.target.src = "/images/avatars/Avatar2.png"
//                               }}
//                               width="70"
//                               height="70"
//                               alt="player2"
//                               className="rounded-circle border border-2 border-danger shadow-sm"
//                             />
//                             <h6 className="mt-2 fw-semibold text-danger">
//                               {Game?.Accepetd_By?.Name || "Player 2"}
//                             </h6>
//                           </div>
//                         </div>

//                         {/* Amount Section */}
//                         <div className="mt-4 d-flex justify-content-center align-items-center">
//                           <span className="text-muted me-2">Playing for</span>
//                           <img
//                             src={
//                               process.env.PUBLIC_URL +
//                               "/images/LandingPage_img/global-rupeeIcon.png"
//                             }
//                             width="24"
//                             height="24"
//                             alt="rupee"
//                           />
//                           <span className="fw-bold fs-5 ms-1 text-dark">
//                             {Game?.Game_Ammount || 0}
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   <div className='thin-divider-x my-3' />

//                   <div className='battle_card_main'>
//                     {(Game.Room_code == null && (
//                       <div className=' cxy flex-column'>
//                         <h6 className='headings'> Waiting for Room Code... </h6>
//                         <h6 className='headings'>रूम कोड का इंतजार है।</h6>
//                         <div className='lds-spinner'>
//                           <div></div>
//                           <div></div>
//                           <div></div>
//                           <div></div>
//                           <div></div>
//                           <div></div>
//                           <div></div>
//                           <div></div>
//                           <div></div>
//                           <div></div>
//                           <div></div>
//                           <div></div>
//                         </div>
//                       </div>
//                     )) ||
//                       (Game.Room_code != '0' && (
//                         <div className=' cxy '>
//                           <div className=''>
//                             <h2 className='profile_headings mb-0 mr-3'>
//                               Room Code <span>{Game.Room_code}</span>
//                             </h2>
//                           </div>
//                           <button
//                             className='bg-green playButton position-static mt-0'
//                             onClick={e => copyCode(e)}
//                           >
//                             Copy Code
//                           </button>
//                         </div>
//                       )) ||
//                       (Game.Room_code == '0' &&
//                         ((Game.Created_by._id == user &&
//                           Game.Room_code == '0' && (
//                             <div className=' cxy flex-column'>
//                               <>
//                                 {showDiv ? (
//                                   <div className=' cxy flex-column'>
//                                     <h6 className='headings'>
//                                       {' '}
//                                       Set Room Code{' '}
//                                     </h6>
//                                     <h6 className='headings'>
//                                       लूडो किंग से रूम कोड अपलोड करें
//                                     </h6>

//                                     <input
//                                       type='number'
//                                       className='form-control mt-1 w-75'
//                                       style={{
//                                         backgroundColor: '#e8eeee',
//                                         border: '1px solid red'
//                                       }}
//                                       value={roomcode}
//                                       onChange={e =>
//                                         setRoomcode(e.target.value)
//                                       }
//                                     />
//                                     <button
//                                       className='bg-green playButton position-static mt-2'
//                                       type='button'
//                                       onClick={handleSetRoomCode}
//                                     >
//                                       SET ROOM CODE
//                                     </button>
//                                   </div>
//                                 ) : (
//                                   ''
//                                 )}
//                               </>

//                               <div
//                                 className='pt-4 text-primary'
//                                 style={{
//                                   fontWeight: 'bold',
//                                   fontSize: '20px'
//                                 }}
//                               >
//                                 {showDiv ? (
//                                   <div>
//                                     <p>
//                                       Remaining Time :{' '}
//                                       <span style={{ fontSize: '30px' }}>
//                                         {' '}
//                                         {secondsRemaining}{' '}
//                                       </span>
//                                       seconds
//                                     </p>
//                                   </div>
//                                 ) : (
//                                   <div>
//                                     <p style={{ color: 'red' }}>
//                                       Your Time is Complete please Reset bettel
//                                       !
//                                     </p>
//                                   </div>
//                                 )}
//                               </div>

//                               <div className='rules'>
//                                 <ol className='list-group list-group-numbered'>
//                                   <li
//                                     className='list-group-item'
//                                     style={{
//                                       color: 'red',
//                                       fontSize: '20px !important'
//                                     }}
//                                   >
//                                     <marquee>
//                                       कृपया लूडो किंग से रुम कोड निकल कर SET
//                                       ROOM CODE मे डाल दे
//                                     </marquee>
//                                   </li>
//                                 </ol>
//                               </div>
//                             </div>
//                           )) ||
//                           (Game.Accepetd_By._id == user &&
//                             Game?.Room_code == '0' && (
//                               <div className='roomCode cxy flex-column'>
//                                 <>
//                                   {showDiv ? (
//                                     <>
//                                       <div
//                                         style={{
//                                           textAlign: 'center',
//                                           marginBottom: '10px'
//                                         }}
//                                       >
//                                         <h6 className='headings'>
//                                           {' '}
//                                           Waiting for Room Code{' '}
//                                         </h6>
//                                         <h6 className='headings'>
//                                           रूम कोड का इंतजार है। [
//                                           {secondsRemaining}]
//                                         </h6>

//                                         <div className='lds-spinner'>
//                                           <div></div>
//                                           <div></div>
//                                           <div></div>
//                                           <div></div>
//                                           <div></div>
//                                           <div></div>
//                                           <div></div>
//                                           <div></div>
//                                           <div></div>
//                                           <div></div>
//                                           <div></div>
//                                           <div></div>
//                                         </div>
//                                       </div>
//                                     </>
//                                   ) : (
//                                     <div>
//                                       <p style={{ color: 'red' }}>
//                                         Your Time is Complete please Reset
//                                         bettel !
//                                       </p>
//                                     </div>
//                                   )}
//                                 </>

//                                 <div className='rules'>
//                                   <ol className='list-group list-group-numbered'>
//                                     <li
//                                       className='list-group-item'
//                                       style={{
//                                         color: 'red',
//                                         fontSize: '20px !important'
//                                       }}
//                                     >
//                                       <marquee>
//                                         {' '}
//                                         कृपया इंतजार करे सामने वाला यूजर लूडो
//                                         किंग से रूम कोड निकल कर दे रहा  है{' '}
//                                       </marquee>
//                                     </li>
//                                   </ol>
//                                 </div>
//                               </div>
//                             ))))}
//                   </div>

//                   <div className='cxy app-discription flex-column'>
//                     <span style={{ opacity: '.8' }}>
//                       {' '}
//                       Play ludo game in Ludo King App
//                     </span>
//                     <div className='mt-2'>
//                       <a
//                         href='https://play.google.com/store/apps/details?id=com.ludo.king'
//                         target='_blank'
//                         rel='noopener noreferrer'
//                       >
//                         <img
//                           className='mr-2'
//                           src={
//                             process.env.PUBLIC_URL + '/Images/google-play.jpeg'
//                           }
//                           width='128px'
//                           height='38px'
//                           alt=''
//                         />
//                       </a>
//                       <a
//                         href='https://itunes.apple.com/app/id993090598'
//                         target='_blank'
//                         rel='noopener noreferrer'
//                       >
//                         <img
//                           src={
//                             process.env.PUBLIC_URL + '/images/app-store.jpeg'
//                           }
//                           width='128px'
//                           height='38px'
//                           alt=''
//                         />
//                       </a>
//                     </div>
//                   </div>
//                   <div className='thin-divider-x my-3' />

//                   <div className='match-status-border row'>
//                     <div className='col-6'>Match Status</div>
//                   </div>
//                   <form
//                     className='result-area'
//                     onSubmit={e => {
//                       Result(e)
//                     }}
//                     encType='multipart/form-data'
//                   >
//                     {fecthStatus !== null && fecthStatus !== undefined && (
//                       <p>
//                         You have already updated your battle result for{' '}
//                         <h6 className='d-inline-block text-uppercase'>
//                           <b>{fecthStatus}</b>
//                         </h6>
//                       </p>
//                     )}
//                     {fecthStatus === null && (
//                       <>
//                         {' '}
//                         <p>
//                           After completion of your game, select the status of
//                           the game and post your screenshot below.
//                         </p>
//                         <div
//                           className='MuiFormGroup-root radios'
//                           role='radiogroup'
//                           aria-label='Result'
//                         >
//                           <label className='MuiFormControlLabel-root hidden Mui-disabled'>
//                             <span
//                               className='MuiButtonBase-root MuiIconButton-root jss1 MuiRadio-root MuiRadio-colorSecondary jss2 Mui-checked jss3 Mui-disabled MuiIconButton-colorSecondary Mui-disabled Mui-disabled'
//                               tabIndex={-1}
//                               aria-disabled='true'
//                             >
//                               <span className='MuiIconButton-label'>
//                                 <input
//                                   className='jss4 mr-2'
//                                   name='battleResult'
//                                   type='radio'
//                                   defaultValue='select'
//                                   defaultChecked
//                                   style={{ transform: 'scale(1.5)' }}
//                                 />
//                               </span>
//                             </span>
//                             <span
//                               className='MuiTypography-root MuiFormControlLabel-label Mui-disabled MuiTypography-body1'
//                               style={{ marginTop: '3px' }}
//                             >
//                               (Disabled option)
//                             </span>
//                           </label>
//                           <label className='MuiFormControlLabel-root'>
//                             <span
//                               className='MuiButtonBase-root MuiIconButton-root jss1 MuiRadio-root jss8'
//                               aria-disabled='false'
//                             >
//                               <span className='MuiIconButton-label'>
//                                 <input
//                                   className='jss4 mr-2'
//                                   name='battleResult'
//                                   type='radio'
//                                   defaultValue='winn'
//                                   onClick={e => setStatus('winn')}
//                                   style={{ transform: 'scale(1.5)' }}
//                                 />
//                               </span>
//                               <span className='MuiTouchRipple-root' />
//                             </span>
//                             <span
//                               className='MuiTypography-root MuiFormControlLabel-label MuiTypography-body1'
//                               style={{ marginTop: '3px' }}
//                             >
//                               I Won
//                             </span>
//                           </label>
//                           <label className='MuiFormControlLabel-root'>
//                             <span
//                               className='MuiButtonBase-root MuiIconButton-root jss1 MuiRadio-root MuiRadio-colorSecondary MuiIconButton-colorSecondary'
//                               aria-disabled='false'
//                               root='[object Object]'
//                             >
//                               <span className='MuiIconButton-label'>
//                                 <input
//                                   className='jss4 mr-2'
//                                   name='battleResult'
//                                   type='radio'
//                                   defaultValue='lose'
//                                   onClick={() => {
//                                     setStatus('lose')
//                                     alert(
//                                       'Are you sure You Lost? क्या आप सुनिश्चित हैं कि आप हार गए हैं?'
//                                     )
//                                   }}
//                                   style={{ transform: 'scale(1.5)' }}
//                                 />
//                               </span>
//                               <span className='MuiTouchRipple-root' />
//                             </span>
//                             <span
//                               className='MuiTypography-root MuiFormControlLabel-label MuiTypography-body1'
//                               style={{ marginTop: '3px' }}
//                             >
//                               I Lost
//                             </span>
//                           </label>
//                           <label className='MuiFormControlLabel-root'>
//                             <span
//                               className='MuiButtonBase-root MuiIconButton-root jss1 MuiRadio-root'
//                               aria-disabled='false'
//                             >
//                               <span className='MuiIconButton-label'>
//                                 <input
//                                   className='jss4 mr-2'
//                                   name='battleResult'
//                                   type='radio'
//                                   defaultValue='cancelled'
//                                   onClick={() => {
//                                     setStatus('cancelled')
//                                     alert(
//                                       'Are you sure you want to cancel? क्या आप वाकई इसे रद्द करना चाहते हैं?'
//                                     )
//                                   }}
//                                   style={{ transform: 'scale(1.5)' }}
//                                 />
//                               </span>
//                               <span className='MuiTouchRipple-root' />
//                             </span>
//                             <span
//                               className='MuiTypography-root MuiFormControlLabel-label MuiTypography-body1'
//                               style={{ marginTop: '3px' }}
//                             >
//                               Cancel
//                             </span>
//                           </label>
//                         </div>
//                       </>
//                     )}
//                     {status !== null &&
//                       status !== 'cancelled' &&
//                       status !== 'lose' && (
//                         <div className={`${css.doc_upload} mt-5`}>
//                           {/* <input type="file" onChange={(e) => setScrnshot(e.target.files[0])} accept="image/*" required /> */}
//                           {/* ADDED BY TEAM */}
//                           <input
//                             type='file'
//                             onChange={handleChange}
//                             accept='image/*'
//                             required
//                           />
//                           {/* ADDED BY TEAM */}
//                           {!scrnshot && (
//                             <div className='cxy flex-column position-absolute '>
//                               <i class='fa-solid fa-arrow-up'></i>
//                               {/* <img src={process.env.PUBLIC_URL + '/Images/upload_icon.png'} width="17px" alt="" className="snip-img" /> */}
//                               <div className={`${css.sideNav_text} mt-2 `}>
//                                 Upload screenshot.
//                               </div>
//                             </div>
//                           )}
//                           {scrnshot && (
//                             <div className={css.uploaded}>
//                               <img
//                                 src='/images/file-icon.png'
//                                 width='26px'
//                                 alt=''
//                                 style={{ marginRight: '20px' }}
//                               />
//                               <div
//                                 className='d-flex flex-column'
//                                 style={{ width: '80%' }}
//                               >
//                                 <div className={`${css.name} `}>
//                                   {scrnshot.name}
//                                 </div>
//                                 <div className={css.size}>
//                                   {(scrnshot.size / 1024 / 1024).toFixed(2)} MB
//                                 </div>
//                               </div>
//                               <div className='image-block'>
//                                 <img
//                                   src='/images/global-cross.png'
//                                   width='10px'
//                                   alt=''
//                                   onClick={clearImage}
//                                 />
//                               </div>
//                             </div>
//                           )}
//                         </div>
//                       )}
//                     {status !== null && status == 'cancelled' && (
//                       <div class='form-group'>
//                         <textarea
//                           class='form-control border-secondary'
//                           name=''
//                           id=''
//                           rows='3'
//                           onChange={e => {
//                             setReason(e.target.value)
//                           }}
//                           required
//                         ></textarea>
//                       </div>
//                     )}

//                     {/* ADDED BY TEAM */}
//                     <div style={{ width: '100%' }}>
//                       <img src={scrnshot1} style={{ width: '100%' }} />
//                     </div>
//                     {/* ADDED BY TEAM */}

//                     {/* <button type='submit' className='btn btn-danger mt-3 text-white' id="post" onSubmit={(e) => { e.preventDefault(); Result() }}>Post Result</button> */}
//                     {fecthStatus == null && fecthStatus == undefined && (
//                       <input
//                         type='submit'
//                         className='btn btn-danger mt-3 text-white'
//                         id='post'
//                       />
//                     )}
//                   </form>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//       {Boolean(submitProcess) && (
//         <div
//           className='loaderReturn'
//           style={{ zIndex: '99', minHeight: '100vh' }}
//         >
//           <img
//             src={'/images/LandingPage_img/loader1.gif'}
//             style={{ width: '100%' }}
//           />
//         </div>
//       )}
//       <div class='divider-y'></div>
//       <div className='rightContainer'>
//         <Rightcontainer />
//       </div>
//     </>
//   )
// }





import React, { useEffect, useState, useRef } from 'react'
import '../css/viewGame1.css'
import '../css/layout.css'
import axios from 'axios'
import { useHistory, useLocation } from 'react-router-dom'
import Header from '../Components/Header'
import css from '../css/Pan.module.css'
import Rightcontainer from '../Components/Rightcontainer'
import Swal from 'sweetalert2'
import '../css/Loader.css'
import io from '../Components/socket'
import Compressor from 'compressorjs'
import socket from '../Components/socket'
import { addResponseMessage } from 'react-chat-widget'

export default function ViewGame1(props) {
  const history = useHistory();


  const location = useLocation();
  const path = location.pathname.split('/')[2];

  const [Game, setGame] = useState(null);
  const [status, setStatus] = useState(null);
  const [fecthStatus, setFecthStatus] = useState(null);
  const [scrnshot, setScrnshot] = useState(null);
  const [scrnshot1, setScrnshot1] = useState('');
  const [roomcode, setRoomcode] = useState('');
  const [reason, setReason] = useState('');
  const [userAllData, setUserAllData] = useState(null);
  const [user, setUser] = useState(null);
  const [submitProcess, setProcess] = useState(true);
  const [secondsRemaining, setSecondsRemaining] = useState(240);
  const [isTimedOut, setIsTimedOut] = useState(false);
  const [settingData, setSettingData] = useState('')
  // console.log(settingData, "settingData")

  const submitReq = useRef(false);

  useEffect(() => {
    socket.emit('websetting', '');
  }, []);
  useEffect(() => {
    socket.on("websettingGet", (data) => {
      localStorage.setItem("sitSetting", JSON.stringify(data));
      setSettingData(data);
    });

    socket.on("recive-msg", (msgs) => {
      if (msgs?.sender !== user?._id) addResponseMessage(msgs.text);
    });
  }, [user]);
  const role = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      history.push('/login');
      return;
    }
    const headers = { Authorization: `Bearer ${token}` };
    try {
      const res = await axios.get(`https://api.rrludo.in/me`, { headers });
      setUser(res.data._id);
      setUserAllData(res.data);
      fetchGameDetails(res.data._id);
    } catch (e) {
      if (e.response?.status === 401) handleLogout();
    }
  };

  const fetchGameDetails = async (userId) => {
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };
    try {
      const res = await axios.get(`https://api.rrludo.in/challange/${path}`, { headers });
      const gameData = res.data;
      setGame(gameData);

      if (gameData.Status === 'new' || gameData.Status === 'requested') {
        setTimeout(() => history.push(props.location.state?.prevPath || '/'), 5000);
      } else {
        setProcess(false);
      }

      if (userId === gameData.Accepetd_By?._id) setFecthStatus(gameData.Acceptor_status);
      if (userId === gameData.Created_by?._id) setFecthStatus(gameData.Creator_Status);

    } catch (e) {
      console.error(e);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.reload();
    history.push('/login');
  };

  useEffect(() => {
    if (!Game?.createdAt || (Game.Room_code && Game.Room_code !== '0')) return;

    const timer = setInterval(() => {
      const diff = Math.floor((new Date().getTime() - new Date(Game.createdAt).getTime()) / 1000);
      const remaining = 240 - diff;

      if (remaining <= 0) {
        setSecondsRemaining(0);
        setIsTimedOut(true);
        clearInterval(timer);
      } else {
        setSecondsRemaining(remaining);
      }
    }, 1000);
    return () => clearInterval(timer);
  }, [Game]);

  useEffect(() => { role(); }, []);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setScrnshot1(URL.createObjectURL(file));

    if (file.size / 1024 > 300) {
      new Compressor(file, {
        quality: 0.6,
        success(result) { setScrnshot(result); },
      });
    } else {
      setScrnshot(file);
    }
  };

  const submitRoomCode = async () => {
    if (isTimedOut) return Swal.fire("Expired", "Time is up! Please cancel the match.", "error");

    if (!/^[0-9]{8}$/.test(roomcode) || roomcode[0] !== '0') {
      return Swal.fire("Invalid Code", "Enter an 8-digit code starting with 0", "error");
    }
    const token = localStorage.getItem('token');
    try {
      await axios.patch(`https://api.rrludo.in/challange/roomcode/${path}`,
        { Room_code: roomcode },
        { headers: { Authorization: `Bearer ${token}` } });
      window.location.reload();
    } catch (e) {
      Swal.fire("Error", "Could not set room code", "error");
    }
  };

  // const submitAutoRoomCode = async () => {
  //   if (isTimedOut) return Swal.fire("Expired", "Time is up! Please cancel the match.", "error");

  //   if (!/^[0-9]{8}$/.test(roomcode) || roomcode[0] !== '0') {
  //     return Swal.fire("Invalid Code", "Enter an 8-digit code starting with 0", "error");
  //   }
  //   const token = localStorage.getItem('token');
  //   try {
  //     await axios.patch(`https://api.rrludo.in/challange/autoroomcode/${path}`,
  //       { Room_code: roomcode },
  //       { headers: { Authorization: `Bearer ${token}` } });
  //     window.location.reload();
  //   } catch (e) {
  //     Swal.fire("Error", "Could not set room code", "error");
  //   }
  // };

  const submitAutoRoomCode = async () => {
  if (isTimedOut) {
    return Swal.fire("Expired", "Time is up! Please cancel the match.", "error");
  }

  if (!/^[0-9]{8}$/.test(roomcode) || roomcode[0] !== '0') {
    return Swal.fire("Invalid Code", "Enter an 8-digit code starting with 0", "error");
  }

  const token = localStorage.getItem('token');

  try {
    const res = await axios.patch(
      `https://api.rrludo.in/challange/autoroomcode/${path}`,
      { Room_code: roomcode },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    // ✅ Success message (optional)
    Swal.fire("Success", res?.data?.msg || "Room code submitted", "success");

    window.location.reload();
  } catch (e) {
    console.log("API Error:", e?.response?.data);

    const errorMsg =
      e?.response?.data?.msg ||
      e?.response?.data?.message ||
      "Could not set room code";

    Swal.fire("Error", errorMsg, "error");
  }
};
  const handleResultSubmit = async (e) => {
    e.preventDefault();
    if (submitReq.current) return;
    if (!status) return Swal.fire("Wait", "Please select a game result", "warning");
    if (status === 'winn' && !scrnshot) return Swal.fire("Wait", "Please upload winning screenshot", "warning");
    if (status === 'cancelled' && !reason) return Swal.fire("Wait", "Please select a reason for cancellation", "warning");

    submitReq.current = true;
    setProcess(true);

    const formData = new FormData();
    formData.append('file', scrnshot);
    formData.append('status', status);
    if (status === 'cancelled') formData.append('reason', reason);

    try {
      const token = localStorage.getItem('token');
      await axios.post(`https://api.rrludo.in/challange/result/${path}`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      history.push(props.location.state?.prevPath || '/');
    } catch (error) {
      submitReq.current = false;
      setProcess(false);
      Swal.fire("Error", "Failed to update result", "error");
    }
  };


  const handleAutoResultSubmit = async (e) => {
    e.preventDefault();
    if (submitReq.current) return;
    if (status === 'cancelled' && !reason) return Swal.fire("Wait", "Please select a reason for cancellation", "warning");

    submitReq.current = true;
    setProcess(true);

    const formData = new FormData();
    formData.append('file', scrnshot);
    formData.append('status', status);
    if (status === 'cancelled') formData.append('reason', reason);

    try {
      const token = localStorage.getItem('token');
      await axios.post(`https://api.rrludo.in/challange/result-auto/${path}`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      history.push(props.location.state?.prevPath || '/');
    } catch (error) {
      submitReq.current = false;
      setProcess(false);
      Swal.fire("Error", "Failed to update result", "error");
    }
  };

  if (!Game) return (
    <div className="loading-screen">
      <div className="spinner-border text-primary" role="status"></div>
    </div>
  );

  return (
    <div className="game-page-container">
      <Header user={userAllData} />

      <main className="game-content">
        <div className="content-inner">

          {/* Battle Header Card */}
          <div className="ui-card battle-card">
            <div className="players-vs-row">
              <div className="player-col">
                <div className="avatar-box p1-border">
                  <img src={Game?.Created_by?.avatar ? `https://api.rrludo.in/${Game.Created_by.avatar}` : "/images/avatars/Avatar1.png"} alt="P1" />
                </div>
                <span className="player-name">{Game?.Created_by?.Name || 'Player 1'}</span>
              </div>

              <div className="vs-center">
                <div className="vs-badge">VS</div>
                <div className="amount-tag">₹{Game?.Game_Ammount}</div>
              </div>

              <div className="player-col">
                <div className="avatar-box p2-border">
                  <img src={Game?.Accepetd_By?.avatar ? `https://api.rrludo.in/${Game.Accepetd_By.avatar}` : "/images/avatars/Avatar2.png"} alt="P2" />
                </div>
                <span className="player-name">{Game?.Accepetd_By?.Name || 'Player 2'}</span>
              </div>
            </div>
          </div>

          {/* Room Code Section */}
          <div className="ui-card action-card">
            <div className="card-title">Room Code</div>
            {Game.Room_code && Game.Room_code !== '0' ? (
              <div className="room-display-area">
                <div className="room-number">{Game.Room_code}</div>
                <button className="update-btn" onClick={() => { navigator.clipboard.writeText(Game.Room_code); Swal.fire({ title: 'Copied!', timer: 800, icon: 'success' }); }}>
                  <i className="far fa-copy "></i> Copy Code
                </button>
              </div>
            ) : isTimedOut ? (
              <div className="timeout-area">
                <div className="timeout-icon">⚠️</div>
                <p className="timeout-title">Time Expired!</p>
                <p className="timeout-sub">Room code wasn't set in time. Both players should <b>Cancel</b> the match below.</p>
              </div>
            ) : (
              user === Game.Created_by?._id ? (
                <div className="room-input-area">
                  <input type="number" className="room-input" placeholder="Enter Room Code" value={roomcode} onChange={(e) => setRoomcode(e.target.value)} />
                  {settingData?.isGameRules === true ? <button className="update-btn" onClick={submitAutoRoomCode}>Update Auto Code</button> : <button className="update-btn" onClick={submitRoomCode}>Update Code</button>}
                  <p className="timer-text">Time Left: <span className="text-danger">{secondsRemaining}s</span></p>
                </div>
              ) : (
                <div className="waiting-area">
                  <div className="loading-spinner"></div>
                  <p className="wait-title">Waiting for Opponent...</p>
                  <p className="wait-sub">Host has <span className="text-danger">{secondsRemaining}s</span> to set the code.</p>
                </div>
              )
            )}
          </div>

          {/* Result Section */}

          {settingData?.isFairPlay === true ? <div className="ui-card result-card">
            <div className="card-title">Match Auto Result</div>

            {fecthStatus ? (
              <div className="already-submitted">
                <div className="status-label">{fecthStatus.toUpperCase()}</div>
                <p>Result already submitted</p>
              </div>
            ) : (
              <form onSubmit={handleAutoResultSubmit}>
                <div className="result-options">
                  <div className={`opt-box ${status === 'winn' ? 'active-win' : ''}`} onClick={() => !isTimedOut && setStatus('winn')}>
                    <div className="opt-icon win">🏆</div>
                    <span>I Won</span>
                  </div>
                  <div className={`opt-box ${status === 'lose' ? 'active-lose' : ''}`} onClick={() => !isTimedOut && setStatus('lose')}>
                    <div className="opt-icon lose">😞</div>
                    <span>I Lost</span>
                  </div>
                  <div className={`opt-box ${status === 'cancelled' ? 'active-cancel' : ''}`} onClick={() => setStatus('cancelled')}>
                    <div className="opt-icon cancel">✕</div>
                    <span>Cancel</span>
                  </div>
                </div>

                {status === 'winn' && (
                  <div className="upload-section" style={{ padding: "10px" }}>
                    {scrnshot1 && (
  <img
    src={scrnshot1}
    alt="Preview"
    style={{
      width: "100%",
      maxWidth: "200px",   // mobile पर ज्यादा से ज्यादा 200px
      height: "auto",
      objectFit: "contain",
      borderRadius: "8px",
      marginTop: "10px"
    }}
  />
)}

                    <input type="file" className="file-input" accept="image/*" onChange={handleImageChange} />
                    <p className="upload-hint">Upload winning screenshot</p>
                  </div>
                )}

                {status === 'cancelled' && (
                  <select className="reason-select" style={{ padding: "10px" }} value={reason} onChange={(e) => setReason(e.target.value)} required>
                    <option value="">-- Choose Reason --</option>
                    {isTimedOut && <option value="Time Expired">Time Expired (Code not set)</option>}
                    <option value="Opponent not joining">Opponent not joining</option>
                    <option value="Game not started">Game not started</option>
                    <option value="Wrong Room Code">Wrong Room Code</option>
                    <option value="Opponent disconnected">Opponent disconnected</option>
                  </select>
                )}

                <button type="submit" className="submit-result-btn" disabled={submitProcess}>
                  {submitProcess ? 'Processing...' : 'Submit Result'}
                </button>
              </form>
            )}
          </div> : <div className="ui-card result-card">
            <div className="card-title">Match Manual Result</div>

            {fecthStatus ? (
              <div className="already-submitted">
                <div className="status-label">{fecthStatus.toUpperCase()}</div>
                <p>Result already submitted</p>
              </div>
            ) : (
              <form onSubmit={handleResultSubmit}>
                <div className="result-options">
                  <div className={`opt-box ${status === 'winn' ? 'active-win' : ''}`} onClick={() => !isTimedOut && setStatus('winn')}>
                    <div className="opt-icon win">🏆</div>
                    <span>I Won</span>
                  </div>
                  <div className={`opt-box ${status === 'lose' ? 'active-lose' : ''}`} onClick={() => !isTimedOut && setStatus('lose')}>
                    <div className="opt-icon lose">😞</div>
                    <span>I Lost</span>
                  </div>
                  <div className={`opt-box ${status === 'cancelled' ? 'active-cancel' : ''}`} onClick={() => setStatus('cancelled')}>
                    <div className="opt-icon cancel">✕</div>
                    <span>Cancel</span>
                  </div>
                </div>

                {status === 'winn' && (
                  <div className="upload-section" style={{ padding: "10px" }}>
                    {/* {scrnshot1 && <img src={scrnshot1} className="img-preview" alt="Preview" />} */}
                    {scrnshot1 && (
  <img
    src={scrnshot1}
    alt="Preview"
    style={{
      width: "100%",
      maxWidth: "200px",   // mobile पर ज्यादा से ज्यादा 200px
      height: "auto",
      objectFit: "contain",
      borderRadius: "8px",
      marginTop: "10px"
    }}
  />
)}

                    <input type="file" className="file-input" accept="image/*" onChange={handleImageChange} />
                    <p className="upload-hint">Upload winning screenshot</p>
                  </div>
                )}

                {status === 'cancelled' && (
                  <select className="reason-select" style={{ padding: "10px" }} value={reason} onChange={(e) => setReason(e.target.value)} required>
                    <option value="">-- Choose Reason --</option>
                    {isTimedOut && <option value="Time Expired">Time Expired (Code not set)</option>}
                    <option value="Opponent not joining">Opponent not joining</option>
                    <option value="Game not started">Game not started</option>
                    <option value="Wrong Room Code">Wrong Room Code</option>
                    <option value="Opponent disconnected">Opponent disconnected</option>
                  </select>
                )}

                <button type="submit" className="submit-result-btn" disabled={submitProcess}>
                  {submitProcess ? 'Processing...' : 'Submit Result'}
                </button>
              </form>
            )}
          </div>}



        </div>
      </main>

      <style>{`
                .game-page-container { background: #f8f9fa; min-height: 100vh; display: flex; flex-direction: column; }
                .game-content { flex: 1; padding: 15px; padding-bottom: 80px; margin-top: 10px; }
                .content-inner { max-width: 500px; margin: 0 auto; }
                .ui-card { background: #fff; border-radius: 12px; padding: 15px; margin-bottom: 15px; box-shadow: 0 2px 8px rgba(0,0,0,0.05); border: 1px solid #eee; }
                .card-title { font-weight: 700; font-size: 1rem; margin-bottom: 15px; color: #333; border-bottom: 1px solid #f0f0f0; padding-bottom: 8px; }

                /* Battle Card */
                .players-vs-row { display: flex; justify-content: space-between; align-items: center; padding: 10px 0; }
                .player-col { flex: 1; text-align: center; }
                .avatar-box { width: 65px; height: 65px; margin: 0 auto 8px; border-radius: 50%; padding: 3px; }
                .avatar-box img { width: 100%; height: 100%; border-radius: 50%; object-fit: cover; }
                .p1-border { border: 2px solid #007bff; }
                .p2-border { border: 2px solid #dc3545; }
                .player-name { font-size: 0.8rem; font-weight: 700; display: block; }
                .vs-badge { font-weight: 900; font-style: italic; font-size: 1.4rem; color: #ff4d4d; }
                .amount-tag { background: #e7f9ed; color: #28a745; font-weight: 700; padding: 2px 8px; border-radius: 12px; font-size: 0.9rem; margin-top: 5px; display: inline-block; }

                /* Room Code & Timeout */
                .room-number { font-size: 2rem; font-weight: 800; color: #007bff; text-align: center; }
                .room-input { width: 100%; padding: 12px; border: 1px solid #ddd; border-radius: 8px; text-align: center; font-size: 1.2rem; font-weight: 700; margin-bottom: 10px; }
                .update-btn { background: #00c853; color: white; border: none; padding: 12px; border-radius: 8px; width: 100%; font-weight: 700; }
                .timeout-area { text-align: center; padding: 10px; background: #fff5f5; border-radius: 8px; border: 1px solid #feb2b2; }
                .timeout-icon { font-size: 2rem; }
                .timeout-title { font-weight: 800; color: #c53030; margin-top: 5px; }
                .timeout-sub { font-size: 0.85rem; color: #742a2a; }

                /* Result Options */
                .result-options { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 10px; margin-bottom: 20px; }
                .opt-box { background: #fcfcfc; border: 2px solid #eee; border-radius: 12px; padding: 12px 5px; text-align: center; cursor: pointer; transition: 0.2s; }
                .active-win { border-color: #ffc107; background: #fffdf5; }
                .active-lose { border-color: #6c757d; background: #f8f9fa; }
                .active-cancel { border-color: #ff4d4d; background: #fff5f5; }
                
                .submit-result-btn { background: #007bff; color: white; border: none; padding: 14px; border-radius: 8px; width: 100%; font-weight: 700; margin-top: 10px; }
                .loading-screen { height: 100vh; display: flex; align-items: center; justify-content: center; }
                @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
                .loading-spinner { width: 30px; height: 30px; border: 3px solid #f3f3f3; border-top: 3px solid #007bff; border-radius: 50%; animation: spin 1s linear infinite; margin: 0 auto 10px; }
            `}</style>
    </div>
  );
}


